module.exports = __webpack_public_path__ + "static/media/telegram.f0da16fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Media/telegram.svg
// module id = 32
// module chunks = 0